/**
 * start-guest-session-request.ts
 * Copyright © 2020, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Message } from "../general/message";
import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

/**
 * A client transmits a {@link StartGuestSessionRequest} to attempt to begin
 * a session as a guest user.
 */
export class StartGuestSessionRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_START_GUEST_SESSION;
  public static tag : MessageTag = MessageTag.REQ_START_GUEST_SESSION;

  /**
   * Construct a new {@link StartGuestSessionRequest}.
   */
  constructor (
    public isEmbedded : boolean = false,
    public embeddedURL : string = "")
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/auth/start-guest-session-request.ts